import { PALETTE as P } from "../../tokens";

/**
 * FoundationsChoose — "Tap to Choose" (select 1 of N).
 *
 * Props:
 *   options  — [{ value, label }]
 *   onSelect — (value) => void
 *   selected — currently selected value (or null)
 */
export default function FoundationsChoose({ options = [], onSelect, selected }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {options.map((opt) => {
        const isSelected = selected === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onSelect(opt.value)}
            style={{
              width: "100%",
              textAlign: "left",
              padding: "15px 16px",
              borderRadius: 12,
              border: isSelected
                ? `1.5px solid ${P.primary}`
                : `1px solid ${P.border}`,
              background: isSelected ? P.primarySoft : P.bg,
              color: isSelected ? P.primary : P.text,
              fontSize: 14,
              lineHeight: 1.45,
              fontWeight: isSelected ? 600 : 400,
              cursor: "pointer",
              transition: "all 0.15s ease",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
